import { Calendar } from "lucide-react";

interface Props {
  disabled: boolean;
  onClick: () => void;
}

export default function SelectShowsButton({ disabled, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="py-3 pl-3 pr-5 rounded-lg border text-left transition-colors border-gray-200 hover:border-gray-300 disabled:opacity-50"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full flex items-center justify-center bg-[#F2F2F3] stroke-primary-blue">
          <Calendar width={20} height={20} stroke="inherit" />
        </div>
        <div className="flex flex-col gap-y-1">
          <div className="text-sm font-medium text-primary-blue">
            Select shows
          </div>
          <div className="text-xs text-gray-500 font-light">
            Choose upcoming shows
          </div>
        </div>
      </div>
    </button>
  );
}
